import fundingCalculatorUi from '../funding-calculator-ui';
import ajax from '../libs/ajax';
import $ from 'jquery';
export default function() {
  const sopimusDiv = document.querySelector('.sopimus');
  const modalWrapper = document.querySelector('.modal-wrapper');
  const sopimusCarButtons = document.querySelectorAll('.sopimus-car-button');
  const modal = document.getElementById('modal');
  const mainCampaignPage = document.querySelector('main.campaign-page.submodules');
  let currentTopPosition;
  if (modalWrapper) {
    // fix body scroll
    window.addEventListener(
      'scroll',
      function(event) {
        global.topPosition = this.scrollY;
      },
      false
    );

    if (sopimusDiv) {
      if (modal) {
        addEventListenerInput();
        // fcc = fundingCalculatorContainter
        const fcc = document.querySelector('.funding-calculator-container');

        sopimusCarButtons.forEach(button =>
          button.addEventListener('click', event => {
            // Show modal when clicking button
            modalWrapper.classList.remove('hide');
            fixMainPosition();

            // Passing data of selected car into modal
            const data = { ...event.target.previousElementSibling.dataset };

            const dataCar = data.car;
            const dataLeasing = data.leasing;
            const dataMileage = data.mileage;
            fcc.dataset.options = JSON.stringify({
              ...JSON.parse(fcc.dataset.options),
              ...JSON.parse(dataCar),
              leasingOptions: JSON.parse(dataLeasing),
              mileageOptions: JSON.parse(dataMileage)
            });

            //Reset funding calculators
            $('.funding-calculator-container').each((i, item) => {
              const fcu = new fundingCalculatorUi();
              fcu.init(item);
            });

            const baseURL = window.location.pathname;
            const car_id = document.querySelector('input[name="carId"]').value;
            window.history.pushState('car modal', car_id, baseURL + '?car_id=' + car_id);
            addEventListenerInput();
            const contactButton = document.querySelector('.sopimus-monthly-button').children[0];
            contactButton.addEventListener('click', () => window.location.replace('https://www.autosalpa.fi/fi/yhteydenottopyynto/'));
          })
        );

        // Close modal if clicking outside modal
        modalWrapper.addEventListener('click', event => {
          if (event.target === modalWrapper) closeModalAndResetUrl();
        });

        // Close modal if clicking close button
        const closeModalButtons = document.querySelectorAll('.close-modal-button');
        closeModalButtons.forEach(closeModalButton =>
          closeModalButton.addEventListener('click', event => {
            closeModalAndResetUrl();
          })
        );
      }
    }
    formSubmiting();
  }
  function fixMainPosition() {
    mainCampaignPage.style.top = -global.topPosition + 'px';
    mainCampaignPage.style.position = 'fixed';
    mainCampaignPage.style.zIndex = 1000;
    mainCampaignPage.style.width = '100%';
    currentTopPosition = global.topPosition;
  }
  function removeFixMainPosition() {
    window.scrollTo(0, currentTopPosition);
    if (mainCampaignPage.style.position === 'fixed') {
      mainCampaignPage.style.position = '';
      mainCampaignPage.style.top = 0 + 'px';
      mainCampaignPage.style.zIndex = 1;
    }
  }
  function closeModalAndResetUrl() {
    const baseURL = window.location.pathname;
    if (window.location.search !== '') window.history.pushState('car modal', '', baseURL);

    modalWrapper.classList.add('hide');
    removeFixMainPosition();
  }
  function addEventListenerInput() {
    const car_id = document.querySelector('input[name="carId"]').value;
    const baseURL = window.location.pathname;
    const depositInput = document.querySelector('.sopimus-deposit');
    const radioInputs = document.querySelectorAll('input[type="radio"]');

    // Polyfill IE NodeList ForEach
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = Array.prototype.forEach;
    }
    // Radio input url modify
    radioInputs.forEach(radioInput => {
      radioInput.addEventListener('click', () => changeUrl());
    });
    depositInput.addEventListener('change', () => changeUrl());
    function changeUrl() {
      const leasingOptions = document.querySelector('input[name="{{activeMonthlyCategory}}"]:checked').value;
      const mileageOptions = document.querySelector('input[name="{{activeMileageOptions}}"]:checked').value;
      const deposit = document.querySelector('.sopimus-deposit').value;
      window.history.pushState('car modal', car_id, baseURL + '?car_id=' + car_id + '&leasingOptions=' + leasingOptions + '&mileageOptions=' + mileageOptions + '&deposit=' + deposit);
    }
    formSubmiting();
  }
  function formSubmiting() {
    const form = document.querySelector('form');
    const formData = Object.values(form).reduce((obj, field) => {
      obj[field.name] = field.value;
      return obj;
    }, {});
    $('form.sopimus-form')
      .off()
      .on('submit', event => {
        event.preventDefault();

        const alertBox = `<div id="alert-box">
            <div class="alert alert-success alert-dismissible fade show" role="alert">
              <strong>Sähköposti lähetetty!</strong>
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">x</span>
              </button>
            </div>
          </div>`;
        $('.sopimus').append(alertBox);
        ajax.ajaxRequest({
          target: 'sopimusSendEmail',
          method: 'POST',
          data: formData,
          callback: function(response) {
            if (response.status === 200) {
              $('#alert-box').fadeTo(4000, 0, () => $('#alert-box').remove());
              $('.close').click(() => $('#alert-box').remove());
              const baseURL = window.location.pathname;
              if (window.location.search !== '') window.history.pushState('car modal', '', baseURL);
              closeModalAndResetUrl();
            }
          }
        });
      });
  }
}
